import React, { useEffect, useState } from "react";
// import StarIcon from "@mui/icons-material/Star";
// import ApiIcon from "@mui/icons-material/Api";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
// import FavoriteIcon from "@mui/icons-material/Favorite";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/amazonSlice";
// import axios from "axios";
import { Link } from "react-router-dom";
import ProductDetail from "../../components/home/ProductDetail";
import Skeleton from "../../components/ui/Skeleton";

const Tabla = () => {
  const [productData, setProductData] = useState([]);
  const [loading, setLoading] = useState(true); // Initialize loading state

  const items = useSelector((state) => state.amazonReducer.items);
  useEffect(() => {
    const stringInstrumentsData = items.filter(
      (instrument) => instrument.category === "Percussion Instruments"
    );
    setTimeout(() => {
      setProductData(stringInstrumentsData);
      setLoading(false); // Update loading state when data is fetched
    }, 150);
  }, [items]);

  // useEffect(() => {
  //   const fetchStringInstruments = async () => {
  //     try {
  //       const response = await axios.get(
  //         "https://snk-music-store-backend.cyclic.app/instruments"
  //       );

  //       // Filter the response data to include only "String Instruments"
  //       const stringInstrumentsData = response.data.filter(
  //         (instrument) => instrument.category === "Percussion Instruments"
  //       );

  //       setTimeout(() => {
  //         setProductData(stringInstrumentsData);
  //         setLoading(false); // Update loading state when data is fetched
  //       }, 200);
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };
  //   fetchStringInstruments();
  // }, []);

  const dispatch = useDispatch();

  // const [selectedProduct, setSelectedProduct] = useState(null); // Local state to store the selected product
  // const [showProductDetail, setShowProductDetail] = useState(false);
  // Function to show product details
  // const showDetails = (product) => {
  //   setSelectedProduct(product);
  //   setShowProductDetail(true);
  // };

  // Function to hide product details
  // const hideDetails = () => {
  //   setSelectedProduct(null);
  //   setShowProductDetail(false);
  // };

  if (loading) {
    // Show loading indicator
    return (
      // <div className="text-center flex justify-center items-center lg:py-48 py-60">
      //   <div className="loader"></div>
      // </div>
      <Skeleton />
    );
  }

  return (
    <div className="mb-4 animate-fadeIn">
      <div className="my-3 ml-5">
        <Link to="/">Home</Link> / Percussion
        <h1 className="text-center text-4xl pb-2 font-bold">Percussion</h1>
      </div>
      <div className="max-w-screen-2xl mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-10 xl:gap-4 px-4">
        {productData.map((item) => {
          return (
            <div
              key={item.id}
              className="bg-white h-auto border-[1px] border-gray-200 py-6 z-30 hover:border-transparent shadow-none hover:shadow-testShadow duration-200 relative flex flex-col gap-4"
            >
              {" "}
              <span className="text-xs capitalize italic absolute top-2 right-2 text-gray-500">
                {item.category}
              </span>
              <div className="w-full h-auto flex items-center justify-center relative group">
                {/* ========== Product Image Start here ============== */}
                <img
                  className="w-52 h-64 object-contain"
                  src={item.image}
                  alt=""
                />
                {/* ================== Product mini drop down Start here ============ */}
                <ul className="absolute w-full h-8 -bottom-4 flex flex-col justify-center items-end gap-2 pr-2">
                  <li className="productLi">
                    <span
                    // onClick={() => showDetails(item)} // Call showDetails when "View Details" is clicked
                    >
                      <Link to={`/productDetails/${item.id}`}>
                        Details{" "}
                        <span>
                          <ArrowCircleRightIcon />
                        </span>
                      </Link>
                    </span>
                  </li>
                  {/* Conditionally render the ProductDetail component */}
                  {/* {showProductDetail && (
                    <ProductDetail
                      product={selectedProduct}
                      onClose={hideDetails} // Pass onClose function to close ProductDetail
                    />
                  )} */}
                </ul>
                {/* ================== Product mini drop down End here ============== */}
              </div>
              <div className="px-4 py-0 bg-white flex flex-col z-10">
                <div className="flex items-center justify-between">
                  <h2 className="font-titleFont tracking-wide text-lg text-amazon_blue font-medium">
                    {item.title}
                  </h2>
                  <p className="text-sm text-gray-600 font-semibold">
                    Rs.{item.price}
                  </p>
                </div>
                {/* <div>
                <p className="text-sm">{item.description.substring(0, 80)}</p>
                <div className="text-yellow-500 flex">
                  <StarIcon />
                  <StarIcon />
                  <StarIcon />
                  <StarIcon />
                  <StarIcon />/
                </div>
              </div> */}
                <button
                  onClick={() =>
                    dispatch(
                      addToCart({
                        _id: item._id,
                        id: item.id,
                        title: item.title,
                        description: item.description,
                        price: item.price,
                        category: item.category,
                        image: item.image,
                        quantity: 1,
                      })
                    )
                  }
                  className="bg-blue-950 flex items-center justify-center rounded-md px-5 py-2 text-center text-sm font-medium text-white focus:outline-none focus:ring-4 focus:ring-blue-300 hover:bg-blue-900"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="mr-2 h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                  Add to cart
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tabla;
